// Portão de autenticação: decide entre spinner, tela de login e as rotas da
// aplicação, com base no estado do AuthContext.
import { Navigate, Route, Routes } from "react-router-dom";
import App from "./App";
import Login from "./components/Login";
import { useAuth } from "./context/AuthContext";
import HistoryPage from "./pages/HistoryPage";
import RunDetailPage from "./pages/RunDetailPage";

export default function AuthGate() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ backgroundColor: "var(--color-background)" }}
      >
        <p className="text-ink-500 font-body text-sm">Carregando...</p>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/history" element={<HistoryPage />} />
      <Route path="/history/:id" element={<RunDetailPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
